import { SravniOrganizationsSharedOrganizationStatus } from '../__generated__/news/Api';

export enum OrganizationsType {
  BANK = 'bank',
  MFO = 'mfo',
  INSURANCE_COMPANY = 'insuranceCompany',
  SCHOOL = 'educationalOrganization',
}

export interface IOrganizationMenuQuery {
  type: OrganizationsType;
  id: string | number;
  alias: string;
  location: string;
  status: SravniOrganizationsSharedOrganizationStatus;
  counts?: boolean;
}

export interface IMenu {
  href: string;
  label: string;
  isLink?: boolean;
  children?: any[];
  // children: IOrganizationMenu[];
}
